/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_EmptyInputs */

const en_tokens_empty = /** @type {(inputs: Tokens_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tokens yet`)
};

const de_tokens_empty = /** @type {(inputs: Tokens_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Tokens`)
};

/**
* | output |
* | --- |
* | "No tokens yet" |
*
* @param {Tokens_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_empty = /** @type {((inputs?: Tokens_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_empty(inputs)
	return en_tokens_empty(inputs)
});